/* lua.js generated code 0.3.0 */

let wSize = cc.Director.getInstance().getWinSize()
let BUTTON_BOX_POSITION = (isIpad() ? 190 : 280) + _safe_area_bottom

let LOWER_BTNX_OFFSET = 60
let LOWER_BTNX_INTERVAL = 80
let ActionTimeLines = table(
    [1, "kOpen", "open"],
    [1, "kClose", "close"],
    [1, "kNormal", "normal"],
    [1, "kNews", "news"]
)
const IconBoxPosIndex = {
    [BOX_ICON_TYPE.kTop1] :[
        "kInteractiveInvite", //10
        "kTreasureBox", //20
        "kGoldTurn", //30
        "kMysteryIslandExhibition", // 30
    ],
    [BOX_ICON_TYPE.kTop2] :[
        "kNameCard", //10
        "kBag", //20
        "kMail", //30
        "kCompen", //40
        "kMark", // 50
    ],
    [BOX_ICON_TYPE.kBottom] :[
        "kAddress", //10
        "kCdKey", //10
        "kChat", //20
        "kFC", //30
        "kForum", //30
        "kSetting", //40
        "kMark", // 50
    ]
}
let HomeSceneButtonBox = xClass("HomeSceneButtonBox", cc.Node)
HomeSceneButtonBox.prototype.ctor = function (context) {
    let self = this

    self.posIndexMap = {}
    for (let key in IconBoxPosIndex){
        for (let index in IconBoxPosIndex[key] ){
            self.posIndexMap[IconBoxPosIndex[key][index]] = tonumber(index) + 1
        }
    }

    self.context = context
    cc.Node.prototype.ctor.call(self)
    self.isOpen = false
    self.isRunningAnim = false
    self.csNode = cc.CSLoader.createNode("cocos/homeScene_box.csb","")
    let actionTimeLine = cc.CSLoader.createTimeline("cocos/homeScene_box.csb")
    self.csNode.runAction(actionTimeLine)
    self.csNode.actionTimeLine = actionTimeLine
    self.csNode.setPosition(wSize.width, BUTTON_BOX_POSITION)
    self.addChild(self.csNode, 1)
    self.prompt = self.csNode.getChildByName("number")
    self.prompt.setVisible(false)
    self.prompt.setPosition(-63, 45)
    isIpad() && self.csNode.setScale(0.7)
    self.newPanel = QuickCreateAnimNode("cocos/new_icon_box_banzi.csb")
    self.newPanel.setPosition(wSize.width, BUTTON_BOX_POSITION + 80)
    
    self.addChild(self.newPanel, 1)

    self.promptLabel = self.prompt.getChildByName("txt")
    self.promptLabel.setVisible(false)
    self.promptLabel = cc.Label.createWithSystemFont("0", "Arial", 20)
    self.promptLabel.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    self.promptLabel.setAnchorPoint(cc.p(0.5, 0.5))
    self.promptLabel.setPosition(1, 9)
    self.prompt.addChild(self.promptLabel)

    self.blueBG = self.newPanel.getChildByName("db")
    self.whiteBG = self.newPanel.getChildByName("nk2")
    self.nkBG = self.newPanel.getChildByName("nk")
    self.blueBG.setVisible(false);
    self.whiteBG.setVisible(false);
    self.nkBG.setVisible(false);
    //
    let blueNode = ccui.Scale9Sprite.createWithSpriteFrameName("new_icon_box/db.png", cc.rect(116, 86.5, 15, 13));
    self.addChild(blueNode, 1);
    blueNode.setAnchorPoint(1, 0.5)
    blueNode.width = 567.8;
    blueNode.height = 367;

    let pos = self.blueBG.getParent().convertToWorldSpace(self.blueBG.getPosition())
    blueNode.y = pos.y - 55
    blueNode.x = display.width
    blueNode.setVisible(false);
    self.blueNode = blueNode;
    //
    let whiteNode = ccui.Scale9Sprite.createWithSpriteFrameName("new_icon_box/neik2.png", cc.rect(35, 37, 7, 4));
    self.addChild(whiteNode, 1);
    whiteNode.setAnchorPoint(1, 0.5)
    whiteNode.width = 523;
    whiteNode.height = 263;

    pos = self.whiteBG.getParent().convertToWorldSpace(self.whiteBG.getPosition())
    whiteNode.y = pos.y - 35
    whiteNode.x = display.width
    whiteNode.setVisible(false);
    self.whiteNode = whiteNode;
    //
    let nkNode = cc.Sprite.createWithSpriteFrameName("new_icon_box/neik.png");
    self.addChild(nkNode, 1);
    nkNode.setAnchorPoint(0.5, 0.5)
    nkNode.width = 497;
    nkNode.height = 137;

    pos = self.nkBG.getParent().convertToWorldSpace(self.nkBG.getPosition())
    nkNode.y = pos.y
    nkNode.x = whiteNode.x - whiteNode.width / 2;
    nkNode.setVisible(false);
    self.nkNode = nkNode;
    //
    self.buttonNode = self.csNode.getChildByName("btn")
    let btn = UIButton.create(self.buttonNode, true)
    btn.on(UIButtonEvent.Click, function () {
        self.onPopupClicked()
    })
    self.messageCount = 0
    self.setMessageCount(self.messageCount)
    self.upperBtns = table()
    self.lowerBtns = table()
    self.topBtns = table()
    self.gcBtnPos = {}
    self.popAnimLayer = cc.Node.create()
    self.addChild(self.popAnimLayer, 1)
    self.btnLayer = cc.Node.create()
    self.addChild(self.btnLayer, 2)
    self.label = cc.Label.createWithSystemFont("敬请期待", "Arial", 30)
    self.label.setTextColor(cc.color(60, 155, 198, 255))
    self.label.setVisible(false)
    self.btnLayer.addChild(self.label)
}

HomeSceneButtonBox.prototype.onViewChanged = function () {
    let self = this

    self.refreshPosition(BOX_ICON_TYPE.kTop1)
    self.refreshPosition(BOX_ICON_TYPE.kTop2)
    self.refreshPosition(BOX_ICON_TYPE.kBottom)
}

HomeSceneButtonBox.prototype.refreshPosition = function (iconType) {
    let self = this

    if (iconType == BOX_ICON_TYPE.kTop1 || iconType == BOX_ICON_TYPE.kTop2) {
        let itemWidth = 75
        let len = Math.max($len(self.upperBtns), $len(self.topBtns)) 
        // let boxWidth = 480
        let boxWidth = 120 * len
        let interv = (boxWidth - len * itemWidth) / (len + 1)
        let sumPos = 0;
        for (let i = 1, v = self.upperBtns[1]; v; i++, v = self.upperBtns[i]) {
            v.setPosition(cc.p(wSize.width - boxWidth + interv + itemWidth * 0.5 + (itemWidth + interv) * (i - 1), BUTTON_BOX_POSITION + 40))
            sumPos += v.getPositionX()
        }
        self.label.setPosition(sumPos / $len(self.upperBtns), BUTTON_BOX_POSITION + 150)
        for (let i = 1, v = self.topBtns[1]; v; i++, v = self.topBtns[i]) {
            v.setPosition(cc.p(wSize.width - boxWidth + interv + itemWidth * 0.5 + (itemWidth + interv) * (i - 1), BUTTON_BOX_POSITION + 155))
        }
    } else {
        let j;
        for (let i = 1, v = self.lowerBtns[1]; v; i++, v = self.lowerBtns[i]) {
            v.setPosition(cc.p(wSize.width - LOWER_BTNX_OFFSET - (i - 1) * LOWER_BTNX_INTERVAL, BUTTON_BOX_POSITION - 72))
            j=i;
        }
        let fs = cc.director.getOpenGLView().getFrameSize();
        self.gcBtnPos.top =  ((1-(BUTTON_BOX_POSITION - 65)/cc.winSize.height)) * fs.height;
        self.gcBtnPos.left = (wSize.width - LOWER_BTNX_OFFSET - (j - 1) * LOWER_BTNX_INTERVAL)/cc.winSize.width * fs.width
        self.gcBtnPos.scale = cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width
    }
    let maxWidth = Math.max($len(self.upperBtns) * 120, $len(self.topBtns) * 120 , $len(self.lowerBtns) * LOWER_BTNX_INTERVAL + LOWER_BTNX_OFFSET)
    self.newPanel.setScaleX(maxWidth / self.whiteNode.width)
}
HomeSceneButtonBox.prototype.addBtn = function (btn, iconType, name) {
    let self = this
    btn.posIndex = self.posIndexMap[name] || 999
    if (iconType == BOX_ICON_TYPE.kTop1){
        table.insert(self.topBtns, btn)
        table.nonNativeSort(self.topBtns, function (a, b) {
            // body
            var a_index = a.posIndex || 999
            var b_index = b.posIndex || 999
            if (a_index < b_index) {
                return true
            }
        })
    }else if (iconType == BOX_ICON_TYPE.kTop2) {
        table.insert(self.upperBtns, btn)
        table.nonNativeSort(self.upperBtns, function (a, b) {
            // body
            var a_index = a.posIndex || 999
            var b_index = b.posIndex || 999
            if (a_index < b_index) {
                return true
            }
        })
    } else {
        table.insert(self.lowerBtns, btn)
        table.nonNativeSort(self.lowerBtns, function (a, b) {
            // body
            var a_index = a.posIndex || 999
            var b_index = b.posIndex || 999
            if (a_index > b_index) {
                return true
            }
        })
    }

    let textScale = 0.9
    btn.node && btn.node.getChildByName('txt') && btn.node.getChildByName('txt').setScale(textScale)
    btn.getChildByName('txt') && btn.getChildByName('txt').setScale(textScale)
    if (self.isOpen){
        if ($len(self.topBtns) <= 0 ){
            self.label.setVisible(true)
        }else {
            self.label.setVisible(false)
        }
        btn.setVisible(true)
    }else {
        btn.setVisible(false)
    }
    self.btnLayer.addChild(btn)
    self.refreshPosition(iconType)
    console.log(btn.posIndex, "btnpos", iconType, name, self.posIndexMap)
}
HomeSceneButtonBox.prototype.removeBtn = function (btn, iconType) {
    let self = this
    if (iconType == BOX_ICON_TYPE.kTop1){
        table.removebyvalue(self.topBtns, btn)
    }else if (iconType == BOX_ICON_TYPE.kTop2) {
        table.removebyvalue(self.upperBtns, btn)
    } else {
        table.removebyvalue(self.lowerBtns, btn)
    }
    self.btnLayer.removeChild(btn)
    self.refreshPosition(iconType)
}
HomeSceneButtonBox.prototype.playButtonIdleAnim = function () {
    let self = this
    // let actionList = table()
    // let time = 0
    // let key = null
    // if (self.messageCount > 0) {
    //     key = ActionTimeLines.kNormal
    // } else {
    //     key = ActionTimeLines.kNormal
    // }
    // self.playAnimation(key, true)
    self.csNode.actionTimeLine.gotoFrameAndPause(30)
}
HomeSceneButtonBox.prototype.playAnimation = function (key, loop, callback) {
    let self = this
    // body
    if (self.animation && self.animation === key) {
        if (callback) {
            callback()
        }
        return 
    }
    self.newPanel && self.newPanel.setVisible(true)
    // let timeLine = self.csNode.actionTimeLine
    let timeLine = self.newPanel.actionTimeLine
    timeLine.clearLastFrameCallFunc()
    self.animation = key
    timeLine.play(key, loop || false)
    if (key == "appear") {
        self.playIn();
    } else {
        self.playOut();
    }
    if (callback) {
        function over() {
            // body
            timeLine.clearLastFrameCallFunc()
            if (callback) {
                callback()
            }
        }
        timeLine.setLastFrameCallFunc(over)
    }
}
const frameTime = 1 / 30;
HomeSceneButtonBox.prototype.playIn = function () {
    let self = this;
    const scale = self.newPanel.scaleX;
    const offestX = (scale - 1) * self.whiteNode.width / 2;
    const arr = [[231.75, 97], [589.35, 404], [567.8, 367]];
    self.blueNode.setScale(arr[0][0] / arr[2][0] * scale, arr[0][1] / arr[2][1])
    self.blueNode.x = display.width + (self.blueNode.width * (scale - 1)) / 2 - offestX;
    self.blueNode.runAction(cc.Sequence.create(
        cc.DelayTime.create(frameTime),
        cc.CallFunc.create(function () {
            self.blueNode.setVisible(true);
        }),
        cc.ScaleTo.create(frameTime * 5, arr[1][0] / arr[2][0] * scale, arr[1][1] / arr[2][1]),
        cc.ScaleTo.create(frameTime * 5, scale, 1),
    ))

    const arr1 = [[218.9, 48.8], [556, 289.05], [523, 263]];
    self.whiteNode.setScale(arr1[0][0] / arr1[2][0] * scale, arr1[0][1] / arr1[2][1])
    self.whiteNode.x = display.width + (self.whiteNode.width * (scale - 1)) / 2 - offestX;
    self.whiteNode.runAction(cc.Sequence.create(
        cc.DelayTime.create(frameTime * 3),
        cc.CallFunc.create(function () {
            self.whiteNode.setVisible(true);
        }),
        cc.ScaleTo.create(frameTime * 5, arr1[1][0] / arr1[2][0] * scale, arr1[1][1] / arr1[2][1]),
        cc.ScaleTo.create(frameTime * 5, scale, 1),
    ))

    const arr2 = [[365, 100.6], [521, 169], [497, 137]];
    self.nkNode.setScale(arr2[0][0] / arr2[2][0] * scale, arr2[0][1] / arr2[2][1])
    self.nkNode.x = self.whiteNode.x - self.whiteNode.width * scale / 2;
    self.nkNode.runAction(cc.Sequence.create(
        cc.DelayTime.create(frameTime * 4),
        cc.CallFunc.create(function () {
            self.nkNode.setVisible(true);
            self.nkNode.setOpacity(0);
        }),
        cc.Spawn.create(
            cc.FadeTo.create(frameTime * 5, 255),
            cc.ScaleTo.create(frameTime * 5, arr2[1][0] / arr2[2][0] * scale, arr2[1][1] / arr2[2][1]),
        ),
        cc.ScaleTo.create(frameTime * 5, scale, 1),
    ))

}
HomeSceneButtonBox.prototype.playOut = function () {
    let self = this;
    const scale = self.newPanel.scaleX;
    const arr = [[567.8, 367], [636.8, 322.9], [196, 82.95]]
    self.blueNode.runAction(cc.Sequence.create(
        cc.DelayTime.create(frameTime * 2),
        cc.ScaleTo.create(frameTime * 4, arr[1][0] / arr[0][0] * scale, arr[1][1] / arr[0][1]),
        cc.ScaleTo.create(frameTime * 4, arr[2][0] / arr[0][0] * scale, arr[2][1] / arr[0][1]),
        cc.DelayTime.create(frameTime),
        cc.CallFunc.create(function () {
            self.blueNode.setVisible(false);
        }),
    ))

    const arr1 = [[523, 263], [583.5, 231.4], [218.95, 48.8]];
    self.whiteNode.runAction(cc.Sequence.create(
        cc.DelayTime.create(frameTime),
        cc.ScaleTo.create(frameTime * 4, arr1[1][0] / arr1[0][0] * scale, arr1[1][1] / arr1[0][1]),
        cc.ScaleTo.create(frameTime * 4, arr1[2][0] / arr1[0][0] * scale, arr1[2][1] / arr1[0][1]),
        cc.DelayTime.create(frameTime),
        cc.CallFunc.create(function () {
            self.whiteNode.setVisible(false);
        }),
    ))

    const arr2 = [[497, 137], [554.4, 120.6], [292.3, 80.6]];
    self.nkNode.runAction(cc.Sequence.create(
        cc.DelayTime.create(frameTime),
        cc.ScaleTo.create(frameTime * 3, arr2[1][0] / arr2[0][0] * scale, arr2[1][1] / arr2[0][1]),
        cc.Spawn.create(
            cc.FadeTo.create(frameTime * 3, 0),
            cc.ScaleTo.create(frameTime * 3, arr2[2][0] / arr2[0][0] * scale, arr2[2][1] / arr2[0][1]),
        ),
    ))
}

HomeSceneButtonBox.prototype.onPopupClicked = function () {
    let self = this
    if (self.isOpen) {
        // self:close()
        return 
    } else {
        self.open()
    }
}
HomeSceneButtonBox.prototype.open = function () {
    let self = this
    if (self.isOpen || self.isRunningAnim) {
        return 
    }
    cc.UserDefault.getInstance().setBoolForKey("_shown_new_icon_box_", true)
    self.context.updateBoxPrompt()
    if (window.mini){
        SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(false, true)
    }
    self.context.createSideBoxContent()
    self.isOpen = true
    self.isRunningAnim = true
    open_over = function () {
        self.isRunningAnim = false
    
        // if (window.mini && mini.getPlatform() == MiniPlatform.tt){
        //     // 抖音小游戏且宿主app不是抖音的用这个（比如头条，番茄）
        //     self.context.ttShowFAQBtn();
        // }
        if ($len(self.topBtns) <= 0 ){
            self.label.setVisible(true)
        }
    }
    // self.playAnimation(ActionTimeLines.kOpen, false, open_over)
    self.playAnimation("appear", false, open_over)

    self.csNode.getChildByName("btn").runAction(cc.FadeOut.create(0.1))

    // 因为 外部动画构造的节点让 buttonBox 向又移了几个像素，会导致黑背景会有偏移，这里都构造几个像素
    self.layerColor = cc.LayerColor.create(cc.c4b(0, 0, 0, 255), wSize.width + 10, wSize.height)
    self.layerColor.setOpacity(0)
    self.addChild(self.layerColor, -9999)
    self.layerColor.x = -10
    self.layerColor.runAction(cc.FadeTo.create(0.1, 125))
    self.touchLayer = cc.Layer.create()
    self.touchLayer.setContentSize(wSize)
    self.addChild(self.touchLayer, 0)
    // console.log("self.newPanel", self.newPanel.getContentSize())
    quickBuildUIButton(self.touchLayer, ()=>{
        self.close()
    }); 
    UIButton.create(self.blueNode, true);
    // let listenner = cc.EventListenerTouchOneByOne.create()
    // listenner.setSwallowTouches(true)
    // listenner.registerScriptHandler(function (touch, event) {
    //     let pos = self.blueBG.convertToNodeSpace(touch.getLocation())
    //     let rect = cc.rect(0, 0, 543, 235)
    //     if (!cc.rectContainsPoint(rect, pos)) {
    //         setTimeout(() => {
    //             // close 方法里面的 removeListener 会将 listener._registered 标识置为false，导致事件继续向下传递，这里延迟执行 close
    //             self.close()
    //         }, 0);
    //     }
    //     return true
    // }, cc.Handler.EVENT_TOUCH_BEGAN)

    // self.listenner = listenner;
    // cc.eventManager.addListener(self.listenner, self)
    // return
    // let eventDispatcher = self.touchLayer.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listenner, self.touchLayer)
    let $let33 = $len(self.upperBtns)
    for (let i = $let33; i >= 1; i += -1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 2 / 30))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.upperBtns[i].setVisible(true)
            self.upperBtns[i].setScale(0.1)
        }))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(5 / 30, 1.1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 0.9)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 1)))
        self.upperBtns[i].runAction(cc.Sequence.create(actionList))
    }
    let length = $len(self.topBtns)
    for (let i = length; i >= 1; i += -1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 2 / 30))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.topBtns[i].setVisible(true)
            self.topBtns[i].setScale(0.1)
        }))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(5 / 30, 1.1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 0.9)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 1)))
        self.topBtns[i].runAction(cc.Sequence.create(actionList))
    }
    let $let37 = $len(self.lowerBtns)
    for (let i = $let37; i >= 1; i += -1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 3 / 30))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.lowerBtns[i].setVisible(true)
            self.lowerBtns[i].setScale(0.1)
        }))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(5 / 30, 1.1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 0.9)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 1)))
        self.lowerBtns[i].runAction(cc.Sequence.create(actionList))
    }
}
HomeSceneButtonBox.prototype.close = function () {
    let self = this
    if (!self.isOpen || self.isRunningAnim) {
        return 
    }

    if (window.mini){
        SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(true, true)
    }

    self.label.setVisible(false)

    self.isOpen = false
    self.isRunningAnim = true
    let close_over = function () {
        self.newPanel && self.newPanel.setVisible(false)
        self.playButtonIdleAnim()
        self.isRunningAnim = false
    }
    let closeBox = function () {
        // body
        self.playAnimation('disappear', false, close_over)
        self.csNode.getChildByName("btn").runAction(cc.Sequence.create(cc.DelayTime.create(0.2), cc.FadeIn.create(0.1)))
    }
    // if (META.platform == XcloverPlatform.wechatgame) {
    //     if(self.gameClubButton) {
    //         self.gameClubButton.hide()
    //     } 
    // }
    self.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.CallFunc.create(closeBox)))
    if (self.layerColor) {
        self.layerColor.runAction(cc.Sequence.create(cc.FadeOut.create(0.1), cc.CallFunc.create(function () {
            self.layerColor.removeFromParent(true)
            self.layerColor = null
        })))
    }
    if (self.touchLayer) {
        self.touchLayer.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.CallFunc.create(function () {
            self.touchLayer.removeFromParent(true)
            self.touchLayer = null
        })))
    }
    let $limit43 = $len(self.upperBtns)
    for (let i = 1; i <= $limit43; i += 1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 0.8 / 30))
        table.insert(actionList, cc.ScaleTo.create(2 / 30, 1.1))
        table.insert(actionList, cc.ScaleTo.create(3.5 / 30, 0.1))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.upperBtns[i].setVisible(false)
        }))
        self.upperBtns[i].runAction(cc.Sequence.create(actionList))
    }
    let length = $len(self.topBtns)
    for (let i = 1; i <= length; i += 1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 0.8 / 30))
        table.insert(actionList, cc.ScaleTo.create(2 / 30, 1.1))
        table.insert(actionList, cc.ScaleTo.create(3.5 / 30, 0.1))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.topBtns[i].setVisible(false)
        }))
        self.topBtns[i].runAction(cc.Sequence.create(actionList))
    }
    let $limit47 = $len(self.lowerBtns)
    for (let i = 1; i <= $limit47; i += 1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 0.8 / 30))
        table.insert(actionList, cc.ScaleTo.create(2 / 30, 1.1))
        table.insert(actionList, cc.ScaleTo.create(3.5 / 30, 0.1))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.lowerBtns[i].setVisible(false)
        }))
        self.lowerBtns[i].runAction(cc.Sequence.create(actionList))
    }
    // cc.eventManager.removeListener(self.listenner)
    // self.listenner = null
}
HomeSceneButtonBox.prototype.setMessageCount = function (value) {
    let self = this
    self.messageCount = value
    if (self.messageCount > 0) {
        self.prompt.setVisible(true)
        self.promptLabel.setString(UIUtils.getPromptNumStr(self.messageCount))
    } else {
        self.prompt.setVisible(false)
    }
    if (!self.isOpen && !self.isRunningAnim) {
        self.playButtonIdleAnim()
    }
}
HomeSceneButtonBox.prototype.setPromptLabelVisible = function (b) {
    let self = this
    self.promptLabel.setVisible(b)
}
HomeSceneButtonBox.prototype.cleanup = function () {
    let self = this
    if (self.listenner) {
        cc.eventManager.removeListener(self.listenner)
        self.listenner = null
    }
    cc.Node.prototype.cleanup.call(self)
}
module.exports = HomeSceneButtonBox
